import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import {invoicesHelpers} from '../../../../utils/helpers';
import StyledSubscriptionStatusMark from '../../SubscriptionsPage/SubscriptionStatusMark/StyledSubscriptionStatusMark';
import StatusLine from '../../SubscriptionsPage/StatusLine';

const InvoiceStatusMark = ({
  statusCode,
  ...rest
}) => {
  const [t] = useTranslation('main');
  const status = invoicesHelpers.getInvoicePaymentStatus(statusCode);

  return (
    <StyledSubscriptionStatusMark {...rest}>
      <StatusLine color={status.color} /> {t(status.key)}
    </StyledSubscriptionStatusMark>
  );
}

InvoiceStatusMark.propTypes = {
  statusCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

export default InvoiceStatusMark;
